"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6787],{

/***/ 26787:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var WWDCard = function(param) {
    var data = param.data;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("article", {
        className: "_whatWeDoCategories translate-y-12 opacity-0",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "mb-[27px] pl-2",
                children: data.image
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                className: "section-sub-title mb-[35px] !text-[1.85714rem] !leading-8",
                children: data.title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "text-[1rem] leading-[1.42857em] text-[#4A4A4A] ",
                children: data.description
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (WWDCard);


/***/ })

}]);